import {zoom} from 'd3-zoom';
import {select} from 'd3-selection';

import _mark from './_mark';
import _brushZoom from './_brushZoom';
import _tooltip from './_tooltip';
import {className} from '../../modules/util';

function normal() {
  const parent = this.parent();  
  const zoomExtent = this.zoomExtent(this.isColor(), true);
  const zoomGen = zoom()
    .scaleExtent(zoomExtent)
    .translateExtent([[0, 0], [this.width(), this.height()]]);
  this.__execs__.canvas.call(zoomGen); //FIXME: zoomModule을 만들어서 수정

  this.zoomGen(zoomGen).zoomed(() => {
    _mark.call(this, true); //마크 재설정
    select((parent ? parent : this).__execs__.canvas.node().parentNode.parentNode).selectAll(className('tooltip', true)).remove(); //tooltip 완전 리셋을 위해서 필요    
    _tooltip.call(this); //툴팁 재설정
  }, true);
}

function _zoom() {
  if (!this.zoom()) return;
  if (this.zoom() === 'normal') normal.call(this);
  else if (this.zoom() === 'brush') _brushZoom.call(this);
}

export default _zoom;


// WEBPACK FOOTER //
// ./layouts/scatter/_zoom.js